import React from "react";
import cn from "classnames";
import styles from "./TutorInformation.module.sass";
import Card from "../../../components/Card";
import TextInput from "../../../components/TextInput";
import PhoneInput from "../../../components/PhoneInput";

const TutorInformation = ({ className, data, updateData, currentStep }) => {
  // Utiliser directement les données de l'étudiant transmises par le parent
  const studentData = data?.student || {};

  // Gestionnaires pour les changements de données
  const handleStudentChange = (e) => {
    const { name, value } = e.target;
    
    // Mettre à jour les données du tuteur légal
    if (updateData) {
      updateData('legalGuardianInfo', { ...data.legalGuardianInfo, [name]: value });
    }
  };

  const handleDropdownChange = (name, value) => {
    // Mettre à jour les données du tuteur légal
    if (updateData) {
      updateData('legalGuardianInfo', { ...data.legalGuardianInfo, [name]: value });
    }
  };

  // Fusionner les données de l'étudiant avec les modifications en cours
  const currentData = { ...studentData, ...data.legalGuardianInfo };

  return (
    <Card className={cn(styles.card, className)} title="Informations du tuteur légal" classTitle="title-green">
      <div className={styles.group}>
        <TextInput
          className={styles.field}
          label="Nom du tuteur"
          name="legal_guardian_last_name"
          type="text"
          placeholder="Nom"
          value={currentData?.legal_guardian_last_name || ''}
          onChange={handleStudentChange}
          required
        />
        <TextInput
          className={styles.field}
          label="Prénom du tuteur"
          name="legal_guardian_first_name"
          type="text"
          placeholder="Prénom"
          value={currentData?.legal_guardian_first_name || ''}
          onChange={handleStudentChange}
          required
        />
        <TextInput
          className={styles.field}
          label="Email du tuteur"
          name="legal_guardian_email"
          type="email"
          placeholder="email@example.com"
          value={currentData?.legal_guardian_email || ''}
          onChange={handleStudentChange}
          required
        />
        <PhoneInput
          className={styles.field}
          label="Numéro de téléphone"
          name="legal_guardian_phone"
          id="legal_guardian_phone"
          placeholder="+33 6 XX XX XX XX"
          value={currentData?.legal_guardian_phone || ''}
          onChange={handleStudentChange}
          autoComplete="tel"
        />
        
      </div>
    </Card>
  );
};

export default TutorInformation;
